import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AltraParte } from 'src/app/common/models/altraparte';
import { Parte } from 'src/app/common/models/parte';

@Component({
  selector: 'app-step-soggetti-terzi-form',
  templateUrl: './step-soggetti-terzi-form.component.html',
  styleUrls: ['./step-soggetti-terzi-form.component.css']
})
export class StepSoggettiTerziFormComponent implements OnInit {

  currentForm: string;
  form = FORM;
  @Input() parte: Parte;
  @Output() altraParteChange: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();

  constructor(){
  }

  ngOnInit() {
    this.currentForm = (this.parte != null) ? FORM.ASSOCIATIVA : FORM.ANAGRAFICA;
  }

  onEmitAnagrafica(event: Parte){
    this.parte = event;
    this.currentForm = FORM.ASSOCIATIVA;
  }

  onEmitAssociativa(event: AltraParte){
    this.altraParteChange.emit(event);
    this.currentForm = FORM.ANAGRAFICA;
  }

}

export enum FORM{
  ANAGRAFICA = 'anagrafica',
  ASSOCIATIVA = 'associativa'
}
